import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const dotCircleOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.406-6.406Q8-5.826 8-5q-.002.831-.594 1.422A1.91 1.91 0 0 1 6-3a1.96 1.96 0 0 1-1.422-.578A1.96 1.96 0 0 1 4-5q-.001-.826.578-1.406A1.94 1.94 0 0 1 6-7q.826.002 1.406.594m.719-2.266A4.1 4.1 0 0 0 6-9.25a4.17 4.17 0 0 0-2.14.578 4.2 4.2 0 0 0-1.547 1.547A4.17 4.17 0 0 0 1.75-5q0 1.158.563 2.14a4.3 4.3 0 0 0 1.546 1.548A4.23 4.23 0 0 0 6-.75q1.154 0 2.125-.562A4.2 4.2 0 0 0 9.672-2.86 4.17 4.17 0 0 0 10.25-5q-.002-1.154-.578-2.125a4.1 4.1 0 0 0-1.547-1.547m3.063.656Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};